import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import logo from "../../../images/incheon_logo.png";
import { BsJustify, BsX } from "react-icons/bs";
import { Button } from "@mui/material";
import { LoginContext } from "../../../context/users/LoginContextCopy";

function Header() {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const toggleSide = () => {
    setIsOpen(!isOpen);
  };
  const { isLoginState, logout, userRole } = useContext(LoginContext);

  useEffect(() => {
    const windowMatchMedia = window.matchMedia(
      "screen and (max-width : 829px)"
    );
    setIsOpen(!windowMatchMedia.matches);
  }, []);

  window
    .matchMedia("screen and (max-width : 829px)")
    .addEventListener("change", (a) => {
      if (a.matches === false) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    });

  const logoutBtn = (e) => {
    e.preventDefault();
    logout();
    navigate("//");
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="인천로고" onClick={() => navigate("//")} />
      </div>

      <div className="mobile-menu" onClick={toggleSide}>
        {isOpen ? (
          <BsX className="mobile-menuIcon" />
        ) : (
          <BsJustify className="mobile-menuIcon" />
        )}
      </div>

      <div className={`modal ${isOpen ? "" : "hidden"}`} onClick={toggleSide}>
        <nav className="menu" aria-label="Navigation">
          <ul>
            {/* 로그인 상태이고 userRole이 4일 때만 표시되는 메뉴 항목 */}
            {isLoginState ? (
              <>
                <li>
                  <Link to="/ascon">실시간 측정현황</Link>
                </li>
                <li>
                  <Button
                    sx={{
                      color: "inherit",
                      fontSize: "16px",
                      padding: 0,
                      fontWeight: "bold",
                      lineHeight: "1.6",
                    }}
                    onClick={logoutBtn}
                  >
                    로그아웃
                  </Button>
                </li>
              </>
            ) : (
              <>
                {/* 일반 로그인 상태에서 표시되는 메뉴 항목 */}
                <li>
                  <Link to="//">악취신고</Link>
                </li>
                <li>
                  <Link to="/forecast">대기오염 예보</Link>
                </li>
                <li>
                  <Link to="/airService">휴대폰에 추가</Link>
                </li>
                {isLoginState && (
                  <>
                    <li>
                      <Link to="/mainmap">대기질 현황</Link>
                    </li>
                    <li>
                      <Link to="/monitor">실시간 측정현황</Link>
                    </li>
                    <li>
                      <Button
                        sx={{
                          color: "inherit",
                          fontSize: "16px",
                          padding: 0,
                          fontWeight: "bold",
                          lineHeight: "1.6",
                        }}
                        onClick={logoutBtn}
                      >
                        로그아웃
                      </Button>
                    </li>
                  </>
                )}
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
